import React from "react";
import ContentLoader from "../../components/contentLoader";
import styles from "./shirts.module.scss";
import shirtsImage from "../../images/shirts.png";

export default function Shirts() {
  return (
    <div className={`contentContainer ${styles.shirtsWrapper}`}>
      <div className={styles.content}>
        <ContentLoader docName={"shirts"} />
      </div>
      <div className={styles.shirtsImage}>
        <img src={shirtsImage} alt="Shirts" />
      </div>
    </div>
  );
}
